module.exports = __webpack_public_path__ + "img/unit-testing-dashboard-0.68ba296d.png";